import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DataFormatNumberService {

  constructor() { }

  formatInputNumber(n: any) {
    return n.replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }

  unformatInputNumber(num: any) {
    if (num === undefined && num === null) {
      return '';
    }
    return num.toString().replace(/[,\s]+/g, '');
  }

  formatRemoveFirstZero(num: any) {
    return String(Number(num)).replace(/^0+/, '');
  }

  // prevent paste string value
  onPasteUtil(e: ClipboardEvent) {
    const clipboardData = e.clipboardData;
    let pastedText = clipboardData.getData('text');
    pastedText = pastedText.replace(/[-\s]+/g, "").trim();
    if (!isNaN(+pastedText)) {
      if ((pastedText.substring(pastedText.indexOf('.')).length > 3) && (pastedText.indexOf('.') > -1)) {
        e.preventDefault();
        $(this).val(pastedText.substring(0, pastedText.indexOf('.') + 3));
      }
    } else {
      e.preventDefault();
    }
  }

  // pervent special characters for merchant name
  onPasteMerchantName(e: ClipboardEvent) {
    const clipboardData = e.clipboardData;
    let pastedText = clipboardData.getData('text');
    pastedText = pastedText.replace(/[^a-zA-Z0-9]/g, '');
    return pastedText;
  }

  onlyNumberFormat(event: any) {
    if (event.keyCode !== 8 && event.keyCode !== 0 && event.keyCode !== 9 && (event.keyCode < 48 || event.keyCode > 57)) {
      event.preventDefault();
    }
  }

  removeLanguage(event: any) {
    let value = String($(event.target).val());
    const pattern = /[^\u0000-\u007F ]+/;
    value = value.replace(pattern, "");
    $(event.target).val(value);
  }

  onlyEnglish(event: any) {
    // for all english and number only
    const englishAlphabetAndWhiteSpace = /^[a-zA-Z0-9 \b\t]*$/;
    const key = String.fromCharCode(event.which);
    if (!englishAlphabetAndWhiteSpace.test(key)) {
      event.preventDefault();
    }
  }

  userID(event: any) {
    // for input userID with english and number only without space
    const englishAlphabetAndWithoutWhiteSpace =  /^[a-zA-Z0-9]*$/;
    const key = String.fromCharCode(event.which);
    if (!englishAlphabetAndWithoutWhiteSpace.test(key)) {
      event.preventDefault();
    }
  }

  // allow only 2 digit after dot
  twoDigitFormat(event: any) {
    const inputValue = event.target.value;
    if ((inputValue.indexOf('.') !== -1) &&
      (inputValue.substring(inputValue.indexOf('.')).length > 2) &&
      (event.which !== 0 && event.which !== 8) &&
      ($(event.target)[0].selectionStart >= inputValue.length - 2)) {
      event.preventDefault();
    }
    if (((event.keyCode !== 46 || (event.keyCode === 46 && inputValue === '')) ||
      inputValue.indexOf('.') !== -1) && (event.keyCode < 48 || event.keyCode > 57)) {
      event.preventDefault();
    }
  }

  removeFirstZeroNumber(event: any) {
    let inputValue = event.target.value;
    if ((inputValue === '0' && event.key === '0') || (inputValue === '0.' && event.key === '.') || (event.key === 'ArrowUp' || event.key === 'ArrowDown')) {
      event.preventDefault();
    } else if ((inputValue === '' || inputValue === '0') && event.key === '.') {
      event.target.value = '0.';
    } else if ((inputValue === '0' || inputValue === '0.00') && !(event.key === '0' || event.key === '.' || event.key === 'Tab' || event.key === 'ArrowLeft' || event.key === 'ArrowRight' || event.key === 'Backspace')) {
      inputValue = inputValue.replace(/^(0.00|0)/g, '');
      event.target.value = inputValue;
    }
  }

  formatCurrency(input: any, blur: string, currency: string) {
    // appends $ to value, validates decimal side
    // and puts cursor back in right position.

    // get input value
    let inputValue = input.val();

    // don't validate empty input
    if (inputValue === "") { return; }

    // original length
    const originalLength = inputValue.length;

    // initial caret position
    let caretPosition = input.prop("selectionStart");

    // check for decimal
    if (inputValue.indexOf(".") >= 0) {

      // get position of first decimal
      // this prevents multiple decimals from
      // being entered
      const decimalPosition = inputValue.indexOf(".");

      // split number by decimal point
      let leftSide = inputValue.substring(0, decimalPosition);
      let rightSide = inputValue.substring(decimalPosition);

      // add commas to left side of number
      leftSide = this.formatInputNumber(leftSide);

      // validate right side
      rightSide = this.formatInputNumber(rightSide);

      // On blur make sure 2 numbers after decimal
      if (currency === 'USD') {
        if (blur === "blur") {
          rightSide += "00";
        }

        // Limit decimal to only 2 digits
        rightSide = rightSide.substring(0, 2);

        // join number by .
        inputValue = leftSide + "." + rightSide;
      } else {
        // Limit decimal to only 2 digits
        rightSide = rightSide.substring(0, 2);
        inputValue = leftSide + "." + rightSide;
        if (blur === "blur") {
          inputValue = String(Number(this.unformatInputNumber(leftSide)) + (Math.round(Number('0.' + rightSide))));
          inputValue = this.formatInputNumber(inputValue);
        }
      }
    } else {
      // no decimal entered
      // add commas to number
      // remove all non-digits
      inputValue = this.formatInputNumber(inputValue);
      if (currency === 'USD') {
        // final formatting
        if (blur === "blur") {
          inputValue += ".00";
        }
      }
    }

    // send updated string to input
    input.val(inputValue);

    // put caret back in the right position
    if (blur === '') {
      const updatedLength = inputValue.length;
      caretPosition = updatedLength - originalLength + caretPosition;
      input[0].setSelectionRange(caretPosition, caretPosition);
    }
  }

  keyDownOTP(event: any, prev: any, next: any, current: any, pin: any, callback: any) {
    const reg = /\D/g;
    const value = event.key;
    const isValid = !reg.test(value);
    if ((isValid === true) || (96 <= event.keyCode && event.keyCode <= 105)) {
      if (current.value) {
        current.value = '';
      }
      current.value = event.target.value;
      setTimeout(() => {
        if (next) {
          next.focus();
        }
      });
    } else if (event.key === 'Backspace') {
      if (current.value) {
        current.focus();
      } else if (prev) {
        prev.focus();
        event.preventDefault();
      }
    } else if (event.key === 'ArrowLeft') {
      if (prev) {
        prev.focus();
      }
    } else if (event.key === 'ArrowRight') {
      if (next) {
        next.focus();
      }
    } else if (event.key === 'Enter' && pin.length === 6) {
      callback();
    } else {
      event.preventDefault();
    }
  }
}
